import { render, staticRenderFns } from "./StandBy.vue?vue&type=template&id=c37f3b48&scoped=true&"
import script from "./StandBy.vue?vue&type=script&lang=js&"
export * from "./StandBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37f3b48",
  null
  
)

export default component.exports